import { sift } from "radash";

/**
 * Use non-breaking space to add to separation between strings.
 * (Using CSS word-spacing also widens any spaces in individual strings)
 */
export const getDotseparated = (strings: (string | undefined)[]) => sift(strings).join("\xa0 • \xa0");
